export default "__VITE_ASSET__BHD0sMI___"